import ReviewsPage from '../components/Reviews/Reviews';

export default function Reviews() {
  return <ReviewsPage />;
}
